import { isEmpty } from '~/helper'

export const useRouterUtils = () => {
  const updatePathQuery = ($router, newQueries) => {
    const currentQueries = $router.currentRoute.value?.query
    const fullQueries = { ...currentQueries, ...newQueries }
    if(fullQueries && Object.keys(fullQueries)?.length) {
      Object.keys(fullQueries).forEach(
        (k) => isEmpty(fullQueries[k]) && delete fullQueries[k],
      )
    }
    $router.replace({
      query: { ...fullQueries },
    })
  }

  return {
    updatePathQuery,
  }
}
